import { useEffect, useState } from "react";
import { BREAKPOINTS } from "@/utils/constants";

// Standardized responsive layout hook using consistent breakpoints
export const useResponsiveLayout = () => {
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [isTablet, setIsTablet] = useState<boolean>(false);
    const [isDesktop, setIsDesktop] = useState<boolean>(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width < BREAKPOINTS.md);
            setIsTablet(width >= BREAKPOINTS.md && width < BREAKPOINTS.lg);
            setIsDesktop(width >= BREAKPOINTS.lg);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isMobile, isTablet, isDesktop };
};